import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-badge',
    templateUrl: './badge.component.html',
    styleUrls: ['./badge.component.scss']
})
export class BadgeComponent {

    @Input() label: string;
    @Input() subLabel: string;
    /*
    * 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'light'
    * */
    @Input() color: string;
    @Input() rounded: boolean;

}
